import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  // {
  //   _id: 1001,
  //   title: "Home",
  //   link: "/",
  // },
  {
    _id: 1001,
    title: "Shop",
    link: "/",
  },
  {
    _id: 1002,
    title: "About",
    link: "/about",
  },
  {
    _id: 1003,
    title: "Contact",
    link: "contact",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "Cap for Boys",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: "202",
    img: newArrFour,
    productName: "Tea Table",
    price: "180.00",
    color: "Gray",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: 'https://images.pexels.com/photos/3029796/pexels-photo-3029796.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Tea Shirt for Boys",
    price: "35.00",
    color: "Black and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1002,
    img: spfTwo,
    productName: "Tea Table",
    price: "180.00",
    color: "Gray",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1003,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1004,
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1005,
    img: bestSellerOne,
    productName: "Flower Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1006,
    img: bestSellerTwo,
    productName: "New Backpack",
    price: "180.00",
    color: "Gray",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1007,
    img: bestSellerThree,
    productName: "Household materials",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1008,
    img: bestSellerFour,
    productName: "Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores."
  },
  {
    _id: 1009,
    img: newArrOne,
    productName: "Round Table Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1010,
    img: newArrTwo,
    productName: "Smart Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1011,
    img: newArrThree,
    productName: "cloth Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1012,
    img: newArrFour,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1013,
    img: newArrTwo,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },

  {
    _id: 1014,
    img: 'https://images.pexels.com/photos/3252785/pexels-photo-3252785.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Tea Shirt for Girls",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1015,
    img: newArrFour,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1016,
    img: 'https://images.pexels.com/photos/769749/pexels-photo-769749.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Shirt for Boys",
    price: "250.00",
    color: "Blue and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1017,
    img: bestSellerFour,
    productName: "Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1018,
    img: newArrOne,
    productName: "Round Table Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1019,
    img: newArrTwo,
    productName: "Smart Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1020,
    img: newArrThree,
    productName: "cloth Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1021,
    img: 'https://images.pexels.com/photos/2769297/pexels-photo-2769297.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Tea Shirt for Boys",
    price: "25.00",
    color: "White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1022,
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1023,
    img: bestSellerOne,
    productName: "Flower Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1024,
    img: spfOne,
    productName: "Cap for Boys",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1025,
    img: spfTwo,
    productName: "Tea Table",
    price: "180.00",
    color: "Gray",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1026,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1027,
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1028,
    img: bestSellerOne,
    productName: "Flower Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1029,
    img: bestSellerTwo,
    productName: "New Backpack",
    price: "180.00",
    color: "Gray",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1030,
    img: bestSellerThree,
    productName: "Household materials",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1031,
    img: bestSellerFour,
    productName: "Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1032,
    img: newArrOne,
    productName: "Round Table Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1033,
    img: 'https://images.pexels.com/photos/6372181/pexels-photo-6372181.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Jeans for Girls",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1034,
    img: newArrThree,
    productName: "cloth Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1035,
    img: newArrFour,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1036,
    img: newArrTwo,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1037,
    img: newArrFour,
    productName: "Funny toys for babies",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1038,
    img: newArrTwo,
    productName: "Smart Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1039,
    img: bestSellerFour,
    productName: "Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1040,
    img: newArrOne,
    productName: "Round Table Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1041,
    img: 'https://images.pexels.com/photos/9775463/pexels-photo-9775463.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    productName: "Jeans for Boys",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1042,
    img: newArrThree,
    productName: "cloth Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1043,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1044,
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1045,
    img: bestSellerOne,
    productName: "Flower Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
  {
    _id: 1046,
    img: spfOne,
    productName: "Cap for Boys",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Consider the item packaging traditionally seen in brick-and-mortar stores.",
  },
];
// =================== PaginationItems End here =================
